import errorMap from '@gap/backend/util/validations/validation-error-map'
import { z } from 'zod'
import { activeClientStatuses, clientStatuses } from '@gap/utils/clients/clientStatus'
export { activeClientStatuses, clientStatuses }

export const ClientStatusEnumSchema = z.enum(clientStatuses, { errorMap })
export type ClientStatusEnum = z.output<typeof ClientStatusEnumSchema>

export const ActiveClientStatusEnumSchema = z.enum(activeClientStatuses, { errorMap })
export type ActiveClientStatusEnum = z.output<typeof ActiveClientStatusEnumSchema>
